import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { getOperationPackages } from "./-query";
import { SearchSchema } from "./-zod-schemas";

export const Route = createFileRoute("/_staff/contractor-core/_packages/")({
  validateSearch: zodValidator(SearchSchema),
  loader: async () => {
    const operationPackages = await getOperationPackages();
    return { operationPackages };
  },
});
